import { z } from 'zod';
import { EntryKinds } from './IEntry.js';
import { inputEntrySchema } from './InputEntry.js';
import { legacyCanvasShapeEntrySchema } from './LegacyCanvasShapeEntry.js';
import { tableEntrySchema } from './TableEntry.js';

const entrySchema = z.discriminatedUnion("kind", [
  inputEntrySchema,
  legacyCanvasShapeEntrySchema,
  tableEntrySchema
]);
function isInputEntry(entry) {
  return (entry == null ? void 0 : entry.kind) === EntryKinds.INPUT;
}
function isLegacyCanvasShapeEntry(entry) {
  return (entry == null ? void 0 : entry.kind) === EntryKinds.LEGACY_CANVAS_SHAPE;
}
function isTableEntry(entry) {
  return (entry == null ? void 0 : entry.kind) === EntryKinds.TABLE;
}

export { EntryKinds, entrySchema, inputEntrySchema, isInputEntry, isLegacyCanvasShapeEntry, isTableEntry, legacyCanvasShapeEntrySchema, tableEntrySchema };
//# sourceMappingURL=index.js.map
